module.exports = __webpack_public_path__ + "img/re_successRight.ce71fdaf.png";